import * as React from 'react';

/**
 * The phone breakpoint shared by VoIP layout rules in `components.css` and the
 * `phoneDisplayedKey` derivation in `useVoipConnections`. Exported so consumers
 * can verify what "phone" means without reading this hook's body.
 */
export const PHONE_MEDIA_QUERY = '(max-width: 629px)';

const subscribe = (callback: () => void): (() => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mql = window.matchMedia(PHONE_MEDIA_QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
};

const getSnapshot = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(PHONE_MEDIA_QUERY).matches;
};

const getServerSnapshot = (): boolean => false;

/**
 * Returns `true` when the viewport matches the phone breakpoint
 * (`max-width: 629px`). Backed by `useSyncExternalStore` so concurrent renders
 * see a consistent snapshot and the listener is attached on a per-mount basis.
 */
const useIsPhone = (): boolean => React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useIsPhone;
